import File from './file';
import ModificationTable from './modificationtable';
import ModificationObject from './modifiedobject';
import Modification from './modification';

export default {
  File,
  ModificationTable,
  ModificationObject,
  Modification,
};
